import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PasiToast} from '@shared/models/toast.model';
import {CircleAuthorizationAdd, CircleAuthorization} from '@shared/models/circle-authorization.model';
import {PermissionService} from './permission.service';

@Injectable({
  providedIn: 'root'
})
export class CircleService {

  constructor(
    private http: HttpClient,
    private permissionService: PermissionService
  ) { }

  async getAuthorizationsAccepted(): Promise<CircleAuthorization[]> {
    const url = '/api/v1/authorize/user/my/authorized';
    return this.http.get<CircleAuthorization[]>(url).toPromise();
  }

  async getAuthorizationsSent(): Promise<CircleAuthorization[]> {
    const url = '/api/v1/authorize/user/my/authorized/pending';
    return this.http.get<CircleAuthorization[]>(url).toPromise();
  }

  async getAuthorizationsByAccepted(): Promise<CircleAuthorization[]> {
    const url = '/api/v1/authorize/user/authorized/by';
    return this.http.get<CircleAuthorization[]>(url).toPromise();
  }

  async getHasAuthorizedPatients(): Promise<boolean> {
    if (!this.permissionService.hasPermission('my_circle:get_authorized_by')) {
      return false;
    }

    try {
      return (await this.getAuthorizationsByAccepted())?.length > 0;
    } catch {
      return false;
    }
  }

  async getAuthorizationsToManage(): Promise<CircleAuthorization[]> {
    const url = '/api/v1/authorize/user/authorized/by/pending';
    return this.http.get<CircleAuthorization[]>(url).toPromise();
  }

  async setAuthorizationAccept(authorizationId: number): Promise<void> {
    const url = `/api/v1/authorize/user/invitation/${authorizationId}/accept`;
    await this.http.put(url, {}).toPromise();
  }

  async setAuthorizationReject(authorizationId: number): Promise<void> {
    const url = `/api/v1/authorize/user/invitation/${authorizationId}/reject`;
    await this.http.put(url, {}).toPromise();
  }

  async sendAuthorizedInvitation(model: CircleAuthorizationAdd): Promise<PasiToast> {
    const url = `/api/v1/authorize/user`;
    return this.http.post<PasiToast>(url, model).toPromise();
  }
}
